/**
 * Generated runtime TestId mirror for frontend/src/pages/AutoAssignRuleRequests.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AutoAssignRuleRequestsTestIds = {
  autoAssignRuleRequestsList: "auto-assign-rule-requests-list",
  btnCreateRequest: "btn-create-request",
  colCreatedAt: "col-created-at",
  colName: "col-name",
  colOwner: "col-owner",
  colRequestType: "col-request-type",
  colStatus: "col-status",
  linkRequestDetail: (request_id: string) => `link-request-detail-${request_id}`,
  linkRequestDetailPrefix: () => "link-request-detail-" as TestIdPrefix
} as const;
